import { Icon } from 'deda-rkit';
import * as React from 'react';
import { Link } from 'react-router-dom';

type Props = {
    clickFunction?: React.MouseEventHandler<HTMLAnchorElement>;
    href?: string;
    text: string;
    iconName: string;
}

type State = {

}

/************** COMPONENT PERSONALIZZATO BASATO SUL COMPONENT CardReadMore **************/

/* --------- Attenzione: il colore degli svg renderizzati viene gestito in portal_new.scss --------- */

export default class ReadMoreFA extends React.Component<Props, State> {


    constructor(props) {
        super(props);
    }

    render(): React.ReactNode {
        return (
            <>
                {typeof this.props.clickFunction === 'undefined' ? (
                        <Link to={this.props.href ?? ''} className="read-more">
                            <span className='text'>{this.props.text}</span>
                            {/* <FontAwesomeIcon icon={this.props.iconName} className='icon' color='#007A52' /> */}
                            <Icon
                                className="icon"
                                color="#007A52"
                                icon={this.props.iconName}
                                size=""
                            />
                        </Link>
                    ) : (
                            <a href={this.props.href} onClick={this.props.clickFunction} className="read-more">
                                <span className='text'>{this.props.text}</span>
                                {/* <FontAwesomeIcon icon={this.props.iconName} className='icon' color='#007A52' /> */}
                                <Icon
                                    className="icon"
                                    color="#007A52"
                                    icon={this.props.iconName}
                                    size=""
                                />
                            </a>
                    )}
                    
            </>
        )
    }

}